import React from 'react';
import AppBar from '../../components/AppBar';
import './Terms.css';
import { FaFileContract } from 'react-icons/fa';
import Footer from '../../components/Footer';

const Terms = () => {
  return (
    <div className="terms-page">
      <AppBar backgroundColor="#0a0a0a" />
      <div className="terms-container">
        <div className="terms-header">
          <FaFileContract className="terms-icon" />
          <h1>Terms of Use</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing and using LunaSearch, you agree to be bound by these Terms of Use. 
              If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              LunaSearch provides cryptocurrency search and analysis tools. Our service includes:
            </p>
            <ul>
              <li>Real-time cryptocurrency data and analytics</li>
              <li>Search and filtering capabilities</li>
              <li>Custom alerts and notifications</li>
              <li>API access (for applicable plans)</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. User Accounts</h2>
            <p>When creating an account, you must:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Be at least 18 years old</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any illegal purposes</li>
              <li>Attempt to gain unauthorized access</li>
              <li>Interfere with the service's operation</li>
              <li>Share your account credentials</li>
              <li>Use automated systems to access the service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Intellectual Property</h2>
            <p>
              All content, features, and functionality of LunaSearch are owned by us and are 
              protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Subscription and Payments</h2>
            <p>
              Subscription terms and payment conditions:
            </p>
            <ul>
              <li>Subscriptions are billed in advance</li>
              <li>You can cancel at any time</li>
              <li>Refunds are subject to our refund policy</li>
              <li>Prices may change with notice</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              LunaSearch is provided "as is" without warranties of any kind. We are not liable 
              for any damages arising from the use or inability to use our service.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Data and Privacy</h2>
            <p>
              Your use of LunaSearch is also governed by our Privacy Policy. We collect and 
              process data as described in our Privacy Policy.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Termination</h2>
            <p>
              We may terminate or suspend your access to LunaSearch immediately, without prior 
              notice, for any breach of these Terms of Use.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of 
              any material changes via email or through our website.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of the 
              jurisdiction in which LunaSearch operates, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Contact Information</h2>
            <p>
              For any questions about these Terms of Use, please contact us at:
              <br />
              <a href="mailto:legal@lunasearch.com">legal@lunasearch.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer backgroundColor="#0a0a0a" />
    </div>
  );
};

export default Terms;
